// extracted by mini-css-extract-plugin
export default {"container":"newWhyUs_container__PWOOw","gridContainer":"newWhyUs_gridContainer__OB6Nd"};